import Grid from "@mui/material/Grid2";
import { LocationLink } from "utils/LinkUtils";
import { intl } from "LocaleWrapper";
import { FormGroup } from "@cofano/cck";
import { Fragment, ReactNode } from "react";
import type { AgreementDetailsByTypeProps } from "@schemas/agreements/schema";

type DetailsField = {
	id: string;
	render: () => ReactNode;
}

const WaterwayAgreementDetails = ({ agreement, hiddenFields }: AgreementDetailsByTypeProps) => {

	const WaterwayAgreementDetailsFields: DetailsField[] = [
		{
			id: "agreement.location",
			render: () => (
				<Grid size={4}>
					<FormGroup label={intl.formatMessage({ id: "LOCATION" })} overflow="hidden">
						<LocationLink location={agreement.location} />
					</FormGroup>
				</Grid>
			),
		},
	];

	return (
		<>
			{WaterwayAgreementDetailsFields
				.filter(x => !hiddenFields?.includes(x.id))
				.map(x => (
					<Fragment key={x.id}>
						{x.render()}
					</Fragment>
				))
			}
		</>
	);
};

export default WaterwayAgreementDetails;
